import type { Category, Collection } from '../types/product'
import { images } from './images'

export const livingCategories: Category[] = [
  { id: 'sieraden', title: 'Sieraden', image: images.khamsa },
  { id: 'servies', title: 'Borden & schalen', image: images.safiPlate },
  { id: 'glazen', title: 'Glazen & kopjes', image: images.teaGlasses },
  { id: 'thee', title: 'Thee', image: images.teapot },
  { id: 'decoratie', title: 'Decoratie', image: images.lantern },
]

export const livingCollections: Collection[] = [
  {
    slug: 'bestsellers',
    line: 'living',
    title: 'Populair',
    intro: 'De favorieten van onze klanten: van khamsa tot beldi-theeglazen.',
    kind: 'badge',
    value: 'bestseller',
    seoText:
      'De populairste producten van AMIRA Living: de khamsa ketting van 925 zilver, handbeschilderde Safi-borden, beldi theeglazen met goudrand en de traditionele Marokkaanse theepot.',
  },
  {
    slug: 'nieuw',
    line: 'living',
    title: 'Nieuw',
    intro: 'Net binnen uit Marokko.',
    kind: 'badge',
    value: 'nieuw',
  },
  {
    slug: 'cadeaus',
    line: 'living',
    title: 'Cadeaus',
    intro: 'Stijlvol verpakt, inclusief een gratis kaartje met jouw persoonlijke boodschap.',
    kind: 'badge',
    value: 'cadeau',
    seoText:
      'Marokkaanse cadeaus voor elk moment: een complete thee-ceremonie set, Berber zilveren sieraden, Safi espressokopjes of een koperen lantaarn. Stijlvol verpakt en vóór 22:00 besteld, morgen in huis.',
  },
  {
    slug: 'alles',
    line: 'living',
    title: 'Alle producten',
    intro: 'Handgemaakte sieraden, servies, glazen en decoratie uit Marokko.',
    kind: 'all',
    seoText:
      'AMIRA Living brengt het Marokkaanse huis naar jou: Berber sieraden, handbeschilderd servies uit Safi en Fès, beldi-glazen uit Marrakech, theepotten en decoratie. Gratis verzending vanaf € 50.',
  },
]

export const categories: Category[] = [
  { id: 'sets', title: 'Sets' },
  { id: 'reiniging', title: 'Reiniging' },
  { id: 'scrubtools', title: 'Scrubtools' },
  { id: 'olien', title: 'Oliën' },
  { id: 'bloemenwater', title: 'Bloemenwater' },
  { id: 'make-up-haar', title: 'Make-up & haar' },
  { id: 'geur', title: 'Geur' },
]

export const collections: Collection[] = [
  {
    slug: 'voor-haar',
    title: 'Voor haar',
    intro: 'Omdat iedere vrouw de puurste verzorging verdient.',
    kind: 'audience',
    value: 'haar',
    image: images.her,
    seoText:
      'Bij AMIRA Beauty vind je pure Marokkaanse verzorging voor vrouwen: arganolie en cactusvijgolie voor gezicht en haar, rozenwater als verfrissende toner, ghassoul-klei en Savon Beldi (zwarte zeep) voor het traditionele hammam-ritueel, en natuurlijke make-up zoals kohl en Aker Fassi. Bij elk product lees je de beschrijving, de werking en hoe je het gebruikt — zodat je precies weet wat je koopt.',
  },
  {
    slug: 'voor-hem',
    title: 'Voor hem',
    intro: 'Omdat echte verzorging geen onderscheid maakt.',
    kind: 'audience',
    value: 'hem',
    image: images.him,
    seoText:
      'Natuurlijke verzorging voor mannen: arganolie voor huid en baard, Savon Beldi en een kessa voor een grondige hammam-reiniging, ghassoul voor een frisse huid en hoofdhuid, oranjebloesemwater als verkoelende mist na het scheren en geuroliën als Oud en Musk. Traditionele Marokkaanse producten, eenvoudig in gebruik.',
  },
  {
    slug: 'bestsellers',
    title: 'Bestsellers',
    intro: 'De producten waar onze klanten steeds weer voor terugkomen.',
    kind: 'badge',
    value: 'bestseller',
    image: images.argan,
    seoText:
      'Onze bestsellers zijn de basis van de Marokkaanse huidverzorging: pure arganolie, zwarte zeep (Savon Beldi), de kessa scrubhandschoen, ghassoul-klei en rozenwater. Samen vormen ze het complete hammam-ritueel, ook verkrijgbaar als voordelige Hammam Ritueel Set.',
  },
  {
    slug: 'nieuw',
    title: 'Nieuw',
    intro: 'Nieuw in onze collectie.',
    kind: 'badge',
    value: 'nieuw',
    image: images.cactus,
    seoText:
      'Nieuw bij AMIRA Beauty: cactusvijgolie voor de droge en trekkerige huid, Nila-poeder uit de Sahara voor een frisse, egale uitstraling en Tbrima, ons eigen kruidenpoeder voor een verzorgende bodytreatment.',
  },
  {
    slug: 'cadeaus',
    title: 'Cadeaus',
    intro: 'Stijlvol verpakt om cadeau te geven. Inclusief een gratis kaartje met jouw persoonlijke boodschap.',
    kind: 'badge',
    value: 'cadeau',
    image: images.giftset,
    seoText:
      'Op zoek naar een origineel beautycadeau? Geef de Hammam Ritueel Set, de Geurset Musk & Oud of losse geuroliën en rozenblaadjes. Alle cadeaus worden stijlvol verpakt geleverd, met een gratis kaartje met jouw persoonlijke boodschap. Vóór 22:00 besteld, morgen in huis.',
  },
  {
    slug: 'alles',
    title: 'Alle producten',
    intro: 'Het complete assortiment pure Marokkaanse verzorging.',
    kind: 'all',
    seoText:
      'Ontdek het volledige assortiment van AMIRA Beauty: traditionele Marokkaanse verzorging voor huid, haar en lichaam. Van arganolie, zwarte zeep en ghassoul tot bloemenwaters, natuurlijke make-up en geuroliën. Gratis verzending vanaf € 50 en 30 dagen bedenktijd.',
  },
]
